import React from 'react';
import Maps from './status/maps';

const OrdersMap: React.FC = () => {

  return (
    <React.Fragment>
      <Maps />
    </React.Fragment>
  );
};

export default OrdersMap;